import { render, staticRenderFns } from "./AppraisersList.vue?vue&type=template&id=22eaf6f8&scoped=true&"
import script from "./AppraisersList.vue?vue&type=script&lang=js&"
export * from "./AppraisersList.vue?vue&type=script&lang=js&"
import style0 from "./AppraisersList.vue?vue&type=style&index=0&id=22eaf6f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eaf6f8",
  null
  
)

export default component.exports